import { z } from 'zod'

import type { MapItem } from 'src/shared/schemas/utils'

export type ClientFocus = 'buy' | 'sell' | 'lease' | 'general'

export const ClientFocusMap: Record<ClientFocus, MapItem> = {
  buy: { label: 'Buy' },
  sell: { label: 'Sell' },
  lease: { label: 'Lease' },
  general: { label: 'General' },
}

export const ClientFocusSchema = z.enum(Object.keys(ClientFocusMap) as [ClientFocus, ...ClientFocus[]])
